module.exports = __webpack_public_path__ + "img/art-26.1d66eb5b.png";